import { HashMap } from '@ngneat/transloco';
import { ServiceStack, ServiceStackPort, ServiceStackStatuses, ServiceStackTypes } from './service-stack.model';

export const DISABLED_MENU_ITEM_STATUSES = [
  ServiceStackStatuses.New,
  ServiceStackStatuses.Creating,
  ServiceStackStatuses.ReadyToDeploy
];

// Only states where no container is known to be up. Failure states can still have healthy containers to connect to.
export const DISABLED_INTERACTIVE_MENU_ITEM_STATUSES = [
  ServiceStackStatuses.New,
  ServiceStackStatuses.ReadyToDeploy,
  ServiceStackStatuses.Stopped
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getConfigurationMenuItemTranslation = (typeId: ServiceStackTypes, translations: HashMap<any>) => {

  if (typeId === ServiceStackTypes.Static) {
    return {
      name: translations.menuStaticNginxConfigName,
      desc: translations.menuStaticNginxConfigDesc
    };
  }

  if (typeId === ServiceStackTypes.Nginx || typeId === ServiceStackTypes.PhpNginx) {
    return {
      name: translations.menuNginxConfigName,
      desc: translations.menuNginxConfigDesc
    };
  }

  if (typeId === ServiceStackTypes.ObjectStorage ) {
    return {
      name: translations.menuObjectStorageConfigName,
      desc: translations.menuObjectStorageConfigDesc
    };
  }

};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getLogMenuItemTranslation = (typeId: ServiceStackTypes, translations: HashMap<any>) => {

  if (typeId === ServiceStackTypes.LocalStorage) {
    return {
      name: translations.storageMenuLogName,
      desc: translations.storageMenuLogDesc
    };
  }

  if (typeId === ServiceStackTypes.Seaweedfs) {
    return {
      name: translations.storageMenuLogName,
      desc: translations.seaweedfsMenuLogDesc
    };
  }

  if (
    typeId === ServiceStackTypes.Redis
    || typeId === ServiceStackTypes.Valkey
    || typeId === ServiceStackTypes.MariaDb
    || typeId === ServiceStackTypes.Postgres
    || typeId === ServiceStackTypes.Nats
    || typeId === ServiceStackTypes.Kafka
    || typeId === ServiceStackTypes.Elasticsearch
    || typeId === ServiceStackTypes.Meilisearch
    || typeId === ServiceStackTypes.Typesense
    || typeId === ServiceStackTypes.Clickhouse
  ) {
    return {
      name: translations.databaseMenuLogName,
      desc: translations.databaseMenuLogDesc
    };
  }

  return {
    name: translations.menuLogName,
    desc: translations.menuLogDesc
  };

};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRoutingMenuItemTranslation = (ports: ServiceStackPort[], translations: HashMap<any>) => {

  const httpRouting = ports?.find((itm) => itm.httpRouting);
  const portRouting = ports?.find((itm) => itm.portRouting);

  if (httpRouting && !portRouting) {
    return {
      name: translations.menuRoutingHttpName,
      desc: translations.menuRoutingHttpDesc
    };
  }

  if (httpRouting && portRouting) {
    return {
      name: translations.menuRoutingHttpPortName,
      desc: translations.menuRoutingHttpPortDesc
    };
  }

  return {
    name: translations.menuRoutingPortName,
    desc: translations.menuRoutingPortDesc
  };

};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getAccessDetailsMenuItemTranslation = (typeId: ServiceStackTypes, translations: HashMap<any>) => {

  if (typeId === ServiceStackTypes.MariaDb
    || typeId === ServiceStackTypes.MongoDb
    || typeId === ServiceStackTypes.Redis
    || typeId === ServiceStackTypes.Valkey
    || typeId === ServiceStackTypes.Qdrant
    || typeId === ServiceStackTypes.Postgres
    || typeId === ServiceStackTypes.Clickhouse
  ) {

    return {
      name: translations.menuAccessDetailsName,
      desc: translations.menuAccessDetailsDesc
    };
  }

  if (
    typeId === ServiceStackTypes.Elasticsearch
    || typeId === ServiceStackTypes.Meilisearch
    || typeId === ServiceStackTypes.Typesense
  ) {
    return {
      name: translations.menuAccessDetailsName,
      desc: translations.menuAccessDetailsSearchEngineDesc
    };
  }

  if (
    typeId === ServiceStackTypes.RabbitMq
    || typeId === ServiceStackTypes.Nats
    || typeId === ServiceStackTypes.Kafka
  ) {
    return {
      name: translations.menuAccessDetailsName,
      desc: translations.menuAccessDetailsMessageBrokerDesc
    };
  }

  if (typeId === ServiceStackTypes.Seaweedfs) {
    return {
      name: translations.menuAccessDetailsName,
      desc: translations.menuAccessDetailsStorageDesc
    };
  }

};

export const containsPublicAccess = (v: ServiceStack[]) => {
  return v.some((d) => (d.hasPublicHttpRoutingAccess || d.hasPublicPortRoutingAccess));
};

export const containsNonSystemServiceStacks = (v: ServiceStack[]) => {
  return v.some((d) => !d.isSystem);
}
